module.exports = __webpack_public_path__ + "assets/rain.b012402e.svg";